const NormalLayout = ({ children }) => (
  <div className="page-content">
    {children}
  </div>
);

export default NormalLayout;
